
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gatewaySessions",
      function () {
        return require("private-next-pages/gatewaySessions/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gatewaySessions"])
      });
    }
  